<template>
    <div class="inner">
        <template v-if="checked">
            <Field name="size" :id="radioId + '_' + radioValue" :value="radioValue" v-slot="{ field }">
                <input v-bind="field" type="radio" :checked="checked" class="btn-check"/>
            </Field>
        </template>
        <template v-else>
            <Field name="size" :id="radioId + '_' + radioValue" type="radio" :value="radioValue" :checked="checked" class="btn-check"/>
        </template>
        <label class="btn btn-outline-secondary size-label mb-3" :for="radioId + '_' + radioValue">
            <b class="d-inline-block ms-2">{{ radioValue }}</b>
            <span v-if="sameFrontRear == true"> - Same front and rear</span>
        </label>
    </div>
</template>

<script>
    import { Field } from 'vee-validate';

    export default {
        props: ['radioId', 'radioValue', 'checked', 'sameFrontRear'],
        components: {
            Field
        },
        data() {
            return {
            }
        },
        mounted() {

        },
        methods: {
        },
        computed: {

        }
    }
</script>

<style lang="scss">
    
</style>